// extracted by mini-css-extract-plugin
export default {"container":"NoImagePlaceholder_container__pTb+A","image":"NoImagePlaceholder_image__4wOAL","label":"NoImagePlaceholder_label__qf1w+"};